/**
 * @param {{ number: string, title: string, children: import("react").ReactNode }} props
 */
export default function LicensingClause({ number, title, children }) {
  return (
    <article className="licensing-clause">
      <div className="licensing-clause__layout">
        <div className="licensing-clause__index">{number}</div>
        <div className="licensing-clause__body">
          <h2 className="licensing-clause__title">{title}</h2>
          {children}
        </div>
      </div>
    </article>
  );
}
